<template>
  <div class="padding">
    <div class="d-flex justify-space-between align-center">
      <div class="d-flex align-center mb-3">
        <v-btn class="mr-1" @click="addRelatedProtocol">
          <v-icon class="mr-2">{{ 'mdi-link-box-outline' }}</v-icon>
          Додати пов'язаний протокол
        </v-btn>
        <div class="mr-1">
          <v-tooltip text="Відв'язати протокол">
            <template #activator="{ props: tooltipProps }">
              <div v-bind="tooltipProps">
                <v-menu :close-on-content-click="false">
                  <template #activator="{ props: menuProps }">
                    <v-btn v-bind="menuProps">
                      <v-icon>{{ 'mdi-transit-connection-variant' }}</v-icon>
                    </v-btn>
                  </template>

                  <v-list>
                    <v-list-item
                      v-for="(item, idx) in connections"
                      :key="idx"
                      style="cursor: pointer">
                      <v-list-item-title>
                        <div class="d-flex align-center">
                          <span class="d-block mr-2">{{
                            item.topic || item.name
                          }}</span>
                          <v-btn
                            icon
                            size="small"
                            variant="text"
                            @click="deleteRelatedProtocol(item.id)">
                            <v-icon>{{ 'mdi-close-box-outline' }}</v-icon>
                          </v-btn>
                        </div>
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>
            </template>
          </v-tooltip>
        </div>
        <div v-if="protocol.notActualProtocols.length">
          <v-tooltip text="Переглянути неактуальні протоколи">
            <template #activator="{ props }">
              <v-btn v-bind="props" @click="viewActualProtocol">
                <v-icon>{{ 'mdi-hub-outline' }}</v-icon>
              </v-btn>
            </template>
          </v-tooltip>
        </div>
      </div>
      <v-btn-toggle
        v-model="toggle"
        mandatory
        :rounded="false"
        variant="outlined">
        <v-tooltip text="Відобразити в форматі дерева">
          <template #activator="{ props }">
            <v-btn icon="mdi-sitemap-outline" v-bind="props"></v-btn>
          </template>
        </v-tooltip>
        <v-tooltip text="Відобразити в форматі списка">
          <template #activator="{ props }">
            <v-btn icon="mdi-format-list-bulleted" v-bind="props"></v-btn>
          </template>
        </v-tooltip>
      </v-btn-toggle>
    </div>

    <div v-if="toggle === 0">
      <related-protocols></related-protocols>
    </div>
    <div v-if="toggle === 1">
      <div v-if="parentProtocols.length">
        <div v-for="item in parentProtocols" :key="item.id">
          <RecursiveExpansionPanel :item="item" />
        </div>
      </div>
      <div v-else class="text-disabled text-center">
        Пов'язані протоколи відсутні
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue'
import { navigateToItem } from '@/utils/helpers.js'
import { axios } from '@/plugins'
import { urlProtocolRelatedDelete } from '@/utils/urls.js'
import RecursiveExpansionPanel from '@/components/expansion-panel/RecursiveExpansionPanel.vue'
import { openDialog } from '@/dialog/index.ts'
import RelatedProtocols from '../related-protocols/RelatedProtocols.vue'
import { useRelatedProtocols } from '../related-protocols/relatedProtocols.ts'
import { useProtocol } from '../protocol'

export default {
  name: 'Connections',
  components: {
    RecursiveExpansionPanel,
    RelatedProtocols,
  },
  data: () => {
    return {
      expanded: [],
      toggle: 0,
      headers: [
        {
          title: 'Протокол',
          align: 'start',
          key: 'item',
          sortable: false,
          width: '100%',
        },
      ],
    }
  },
  setup() {
    const { protocol } = useProtocol()
    const {
      relatedProtocols,
      parentProtocols,
      getTreeRelatedProtocols,
      getRelatedProtocols,
    } = useRelatedProtocols()

    const connections = computed(() => {
      return (relatedProtocols.value || []).map(e => ({
        ...e,
        routeName: 'single-protocol',
        protocol: true,
      }))
    })
    const addRelatedProtocol = () => {
      openDialog({
        name: 'RelatedProtocol',
        action: 'create',
        dialogData: {
          protocolId: protocol?.id,
        },
        params: {
          cb() {
            getTreeRelatedProtocols()
            getRelatedProtocols()
          },
          submitLabel: "Зв'язати",
        },
      })
    }

    const viewActualProtocol = () => {
      openDialog({
        name: 'SimpleDialog',
        action: 'create',
        dialogData: {
          nonActualProtocols: protocol?.notActualProtocols || [],
        },
      })
    }

    const deleteRelatedProtocol = relatedProtocolId => {
      return axios
        .delete(urlProtocolRelatedDelete(), {
          data: {
            parentProtocolId: protocol.id,
            childrenProtocolId: relatedProtocolId,
          },
        })
        .then(() => {
          getTreeRelatedProtocols()
          getRelatedProtocols()
        })
    }

    return {
      connections,
      navigateToItem,
      addRelatedProtocol,
      deleteRelatedProtocol,
      viewActualProtocol,
      protocol,
      parentProtocols,
    }
  },
}
</script>

<style lang="scss" scoped>
.main-chip {
  position: relative;

  .chip-line-top {
    width: 1px;
    height: 14px;
    display: block;
    background: #cccccc;
    position: absolute;
    transform: translate(-50%, -50%);
    top: -7px;
    left: 50%;
  }

  .chip-line-bottom {
    width: 1px;
    height: 14px;
    display: block;
    background: #cccccc;
    position: absolute;
    transform: translate(-50%, -50%);
    left: 50%;
    bottom: -20px;
  }

  .chip-line-general {
  }
}
</style>
